import { Immutable } from "immer";
import React from "react";

import type { OfferModule as Value } from "@reactivated";

type IProps = Immutable<{
    value: Value;
}>;

export const OfferModule = (props: IProps): React.JSX.Element => {
    const v = props.value;
    // Legacy used the original image URL (`.file.url` server-side); the
    // serialized ImageChooserBlock exposes the original as `.url`.
    const imageUrl = v.offer_image?.url ?? "";
    // Legacy always rendered the anchor and interpolated `{{ offer_link.url }}`,
    // which collapses to an empty href when the page chooser is unset. Preserve
    // that behavior verbatim for markup parity.
    const linkUrl = v.offer_link?.url ?? "";
    return (
        <div
            className="pdp-offer pdp-section l-full-width"
            style={{ backgroundImage: `url('${imageUrl}')` }}
        >
            <div className="pdp-offer__content l-capped-width">
                <div className="pdp-offer__title pdp-section__title">
                    {v.offer_title}
                </div>
                <div className="pdp-offer__desc pdp-section__desc">
                    {v.offer_description}
                </div>
                <a
                    className="pdp-offer__button button button--white"
                    href={linkUrl}
                >
                    <span>{v.offer_link_name}</span>
                </a>
            </div>
        </div>
    );
};
